import { render, staticRenderFns } from "./ChinaCityTable.vue?vue&type=template&id=25d72fd7&scoped=true"
import script from "./ChinaCityTable.vue?vue&type=script&lang=js"
export * from "./ChinaCityTable.vue?vue&type=script&lang=js"
import style0 from "./ChinaCityTable.vue?vue&type=style&index=0&id=25d72fd7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d72fd7",
  null
  
)

export default component.exports